import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { SharedStockModule } from '../shared/shared.module';
import { DashboardActionsComponent } from './components/dashboard-actions/dashboard-actions.component';
import { DashboardLogWeightedHarvestDialogComponent } from './components/dashboard-log-weighted-harvest-dialog/dashboard-log-weighted-harvest-dialog.component';
import { DashboardProductSelectComponent } from './components/dashboard-product-select/dashboard-product-select.component';
import { DashboardQuickActionDialogComponent } from './components/dashboard-quick-action-dialog/dashboard-quick-action-dialog.component';
import { DashboardRecentActionsComponent } from './components/dashboard-recent-actions/dashboard-recent-actions.component';
import { DashboardRegisterShoppingDialogComponent } from './components/dashboard-register-shopping-dialog/dashboard-register-shopping-dialog.component';
import { DashboardVolatileStockComponent } from './components/dashboard-volatile-stock/dashboard-volatile-stock.component';

@NgModule({
  declarations: [
    DashboardActionsComponent,
    DashboardLogWeightedHarvestDialogComponent,
    DashboardProductSelectComponent,
    DashboardQuickActionDialogComponent,
    DashboardRecentActionsComponent,
    DashboardRegisterShoppingDialogComponent,
    DashboardVolatileStockComponent,
  ],
  imports: [
    AppFormsModule,
    CommonModule,
    FormsModule,
    MaterialModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    SharedStockModule,
  ],
  exports: [DashboardActionsComponent],
})
export class StockDashboardModule {}
